import React, { useContext } from "react";
import { ClientInfoBase } from "../../shared/api/clientTypes";
import { ClientInfo } from "../../shared/reporting/api/biClient.types";
import { defined } from "../../shared/utilities/typeHelper";

export interface Client {
  clientCode: string;
  clientInfo: ClientInfo;
  clients: ClientInfoBase[];
  setClientCode: (clientCode: string) => void;
}

export const ClientContext = React.createContext<Client | undefined>(undefined);

export const useClientContext = () => {
  const client = useContext(ClientContext);
  return defined(client);
};
